import React from 'react';
import { Button } from 'antd';
import './styles.css';

const NotFound = ({ navigate }) => {
    return (
        <div className="not-found">
            <div className="not-found__content">
                <span className="not-found__code">404</span>
                <h1 className="not-found__title">Страница не найдена</h1>
                <p className="not-found__text">
                    Возможно, страница была перемещена или удалена.
                    Попробуйте вернуться на главную или воспользуйтесь каталогом.
                </p>
                <Button
                    type="primary"
                    size="large"
                    className="not-found__btn"
                    onClick={() => navigate('/')}
                >
                    На главную
                </Button>
            </div>
        </div>
    );
};

export default NotFound;
